'use client';

import { createContext, useContext } from 'react';

import type { PopoverProps } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';

interface PopoverState extends Omit<PopoverProps, 'open'> {
  isOpen: boolean;
  anchorEl: PopoverProps['anchorEl'];
  setAnchorEl: Dispatch<SetStateAction<PopoverProps['anchorEl']>>;
  handleClose: (event: MouseEvent | TouchEvent) => void;
  handleOpen: (event: MouseEvent | TouchEvent) => void;
  handleToggle: (event: MouseEvent | TouchEvent) => void;
}

const initialState: PopoverState = {
  isOpen: false,
  anchorEl: void 0,
  setAnchorEl: (element) => element,
  handleOpen: () => void 0,
  handleClose: () => void 0,
  handleToggle: (): void => void 0,
};

export const Context = createContext<PopoverState>( initialState );

export const usePopoverContext = (): PopoverState => useContext<PopoverState>( Context );
